import { render, staticRenderFns } from "./newInstitution.vue?vue&type=template&id=e2b52e90&"
import script from "./newInstitution.vue?vue&type=script&lang=js&"
export * from "./newInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports